import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
export default function PauseIcon(props) {
  return (
    <SvgIcon title="Pause Video" viewBox="0 0 24 24" {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z" />
    </SvgIcon>
  );
}
